import styled from 'styled-components';

export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 13px 22px;
  border: 0;
  border-radius: 8px;
  background: ${p => p.theme.primary};
  color: #fff;
  font-weight: 700;
  line-height: 1;
  box-shadow: 0 4px 16px rgba(0,122,254,0.25);
  transition: background .15s ease, box-shadow .15s ease, opacity .15s ease;

  &:hover { background: ${p => p.theme.primaryStrong}; }
  &:disabled { opacity: .6; cursor: not-allowed; box-shadow: none; }
`;

export const SecondaryButton = styled(Button)`
  background: transparent;
  color: ${p => p.theme.primary};
  border: 1px solid ${p => p.theme.primary};
  box-shadow: none;

  &:hover { background: ${p => p.theme.primarySoft}; }
`;

export const DangerButton = styled(Button)`
  background: transparent;
  color: ${p => p.theme.dangerStrong};
  border: 1px solid ${p => p.theme.border};
  box-shadow: none;

  &:hover { background: ${p => p.theme.dangerSoft}; }
`;

export const ChromeButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 8px;
  background: rgba(255,255,255,0.08);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  transition: background .15s ease;

  &:hover { background: rgba(255,255,255,0.14); }
`;

export const Input = styled.input`
  width: 100%;
  min-width: 0;
  padding: 12px 14px;
  border: 1px solid ${p => p.theme.border};
  border-radius: 8px;
  background: ${p => p.theme.surfaceStrong};
  color: ${p => p.theme.text};
  outline: none;
  transition: border-color .15s ease, box-shadow .15s ease;

  &::placeholder { color: ${p => p.theme.muted}; }
  &:focus {
    border-color: ${p => p.theme.primary};
    box-shadow: 0 0 0 3px ${p => p.theme.primarySoft};
  }
`;

export const Eyebrow = styled.div`
  color: ${p => p.theme.muted};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .1em;
  text-transform: uppercase;
`;

export const Card = styled.section`
  background: ${p => p.theme.surface};
  border: 1px solid ${p => p.theme.border};
  border-radius: 16px;
  box-shadow: ${p => p.theme.shadow};
`;

export const StatusPill = styled.span<{ $ok?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 10px;
  border-radius: 999px;
  background: ${p => (p.$ok ? p.theme.successSoft : p.theme.dangerSoft)};
  color: ${p => (p.$ok ? p.theme.success : p.theme.dangerStrong)};
  font-size: 12px;
  font-weight: 800;
`;

export const EmptyState = styled.div`
  min-height: 280px;
  display: grid;
  place-items: center;
  text-align: center;
  color: ${p => p.theme.muted};
  background: ${p => p.theme.surfaceSoft};
  border: 1px dashed ${p => p.theme.border};
  border-radius: 16px;
  padding: 24px;
`;
